const withFontSizeReset = (editor) => {
  const chain = editor.chain().focus();
  chain.setFontSize?.(null);
  return chain;
};

const setHeading = (editor, { value }) => {
  const level = parseInt(value);
  const validLevel = level >= 1 && level <= 6;
  validLevel && setHeadingLevel(editor, level);
};

const setHeadingLevel = (editor, level) => {
  withFontSizeReset(editor).setHeading({ level }).run();
};

const setParagraph = (editor) => {
  withFontSizeReset(editor).setParagraph().run();
};

export default {
  'text:heading': setHeading,
  'block:paragraph': setParagraph,
};
